import { render, staticRenderFns } from "./TestContainer.vue?vue&type=template&id=5549751b&scoped=true&"
import script from "./TestContainer.vue?vue&type=script&lang=js&"
export * from "./TestContainer.vue?vue&type=script&lang=js&"
import style0 from "./TestContainer.vue?vue&type=style&index=0&id=5549751b&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549751b",
  null
  
)

export default component.exports